import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconSmartHomeTick = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={72}
      height={72}
      fill="none"
      viewBox="0 0 72 72"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g clipPath="url(#clip0_17_76)">
        <path
          d="M68.191 32.789L68.2113 37.1787H64.0452V64.7158C64.0248 66.3619 62.7242 67.6626 61.0984 67.6626H11.5113C9.88548 67.6626 8.76774 66.3416 8.66613 64.7361V37.1787H4.5V33.1548C4.5 31.7729 5.08935 30.4723 6.12581 29.5374L32.3826 6.02419C34.6994 3.99194 38.0119 3.99194 40.3084 6.02419L53.1116 17.2829V11.0642C53.1116 10.4342 53.6603 9.94645 54.331 9.94645H60.3871C61.0577 9.94645 61.6064 10.4342 61.6064 11.0642V24.7819L66.5448 29.1513C67.6016 30.0658 68.191 31.3868 68.191 32.789Z"
          fill="white"
          stroke="white"
          strokeWidth="4.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.1962 53.6625L18.54 40.4113L22.0837 36.701L31.1962 46.2419L50.4337 26.1L53.9775 29.8104L31.1962 53.6625V53.6625Z"
          fill="#662D91"
        />
      </g>
    </SvgIcon>
  );
};
